export const isViewingDcaSite = () => {
  return window.location.hostname.startsWith('dca');
};

export const apiBaseUrl = () => {
  return process.env.REACT_APP_API_URL || `/api`;
};
